/**************************/
/* FUNCIONES PARA BOLETOS */
/**************************/

//OBJETO QUE GESTIONA LA MUESTRA U OCULTACIÓN DE LOS PANELES DE INFORMACIÓN SOBRE LOS BOLETOS
var boletoInfoPanelPro = function(objectNumberChooser,objectPurchaseOption,options){
	this.firstTimeDelay=0; //seg.
	this.callerButtonActOnElem=$("[data-boleto_info][data-infoWizard]");
	this.mobileSetupMultiplesButton="[data-boleto_info_multipleCaller]";
	this.assistantSelectorAttr = "data-helpAssistant";
	this.objectPurchaseOpt=false;
	this.objectChooser=false;

	this.currentModeLangStr= "";
	this.msgToMultiple ="Has seleccionado más números de los establecidos por apuesta. ¿Quieres que te pasemos a modo múltiple con esta combinación? (Se borrarán el resto de tus apuestas)";
	this.msgToNormal ="Estás eligiendo apuesta individual. ¿Estás seguro? (Se borrarán el resto de tus apuestas múltiples)";

	this.multRandom=new core_dropdown();
	this.showWizardOnLoad=true;
	//PRIVADAS
	this.firstColumnUnique=true;
	this.userSwitchedManual=false; //Si el usuario pulsa sobre las pestañas, hace un cambio manual y lo reflejamos
	this.currentMode=false; //wizzard||normal||multiple||reducidas||condicionadas||file

	this.tramosPriceObj=false;
	this.fileSent = false;
 	var parentObj=this;

 	var manuallySwitchedCallback = function(){}
 	this.callbackOnAvailableCondicionadas = function(){}
 	this.callbackOnUnavailableCondicionadas = function(){}

	this.avatarImg = null;

 	if( typeof objectPurchaseOption != "undefined" ){	this.objectPurchaseOpt = objectPurchaseOption }
 	if( typeof objectNumberChooser != "undefined" ){	this.objectChooser = objectNumberChooser }

 	if(typeof options !="undefined"){
 		if( typeof options.firstTimeDelay != "undefined" ){	this.firstTimeDelay = options.firstTimeDelay }
 		if( typeof options.msgToMultiple 	!= "undefined" ){	this.msgToMultiple 	= options.msgToMultiple }
 		if( typeof options.msgToNormal 		!= "undefined" ){	this.msgToNormal 	= options.msgToNormal }
 		if( typeof options.showWizardOnLoad	!= "undefined" ){	this.showWizardOnLoad 	= options.showWizardOnLoad }
 		if( typeof options.tramosPriceObj	!= "undefined" ){	this.tramosPriceObj 	= options.tramosPriceObj }
 		if( typeof options.manuallySwitchedCallback	!= "undefined" ){	this.manuallySwitchedCallback 	= options.manuallySwitchedCallback }
 		if( typeof options.callbackOnAvailableCondicionadas != "undefined"){ this.callbackOnAvailableCondicionadas 	= options.callbackOnAvailableCondicionadas }
 		if( typeof options.callbackOnUnavailableCondicionadas != "undefined"){ this.callbackOnUnavailableCondicionadas 	= options.callbackOnUnavailableCondicionadas }
 	}


 	$('[data-boleto_info] .close-button').add('[data-boleto_info] [data-close-button]').off('click').on('click',function(){
		parentObj.hidePanels();
 	} )
	boletoInfoPanelPro.prototype.resetFileSend = function(){
		$('#betFileSend [data-status-msg]').hide().empty();
		$('#betFileSend [data-ok]').empty();
		$('#betFileSend [data-ko]').empty();
		$('[data-fileverification]').removeClass('is-active');
		this.objectPurchaseOpt.numberChooserObj.resetBoleto();
	}

  	boletoInfoPanelPro.prototype.showPanel = function (panelToShow){
 		if(parentObj.firstTimeDelay > 0){
 			setTimeout(function(){
 				$('[data-boleto_info]').removeClass('is-active');
 					showPanel(panelToShow);
 					parentObj.firstTimeDelay=0;
 				}, this.firstTimeDelay*1000)
		}else{
 			showPanel(panelToShow);
		}
 		function showPanel(panelToShow){
			$('#boleto_tabs li').removeClass('is-active')
			$('#boleto_tabs li a').removeAttr('aria-selected');
 			switch (panelToShow){

 				case "wizard": //Sencilla
				 //boletoInfoPanelPro
				 	if(parentObj.currentMode=="file" && parentObj.fileSent){
						parentObj.resetFileSend();
					}
 					if(parentObj.currentMode!="wizard"){
 						setGameMenu(0);
 						parentObj.hidePanels();
						parentObj.currentMode="wizard";
						$('.navBoleto').add('[data-boleto]').removeAttr('data-isCondicionada').removeAttr('data-isReducida')
	 					$('[data-boleto_info][data-infoWizard]').addClass('is-active');
						parentObj.showCloseButton();
						parentObj.userSwitchedManual=false;
					}

 				break;

 				case "normal": //Sencilla
					if(parentObj.currentMode=="file" && parentObj.fileSent){
						parentObj.resetFileSend();
						if(parentObj.tramosPriceObj){
							parentObj.tramosPriceObj.setUITramo();
							parentObj.tramosPriceObj.updateTramoPrize(0);
						}else{
							parentObj.objectPurchaseOpt.updatePrice(0);
						}
					}
 					if(parentObj.currentMode!="normal"){
 						if(parentObj.currentMode=="multiple" || parentObj.currentMode=="reducida" || parentObj.currentMode=="condicionada" || parentObj.currentMode=="reducida"  || parentObj.currentMode=="reducida" || parentObj.currentMode=="file"){
 							if( !parentObj.objectChooser.isMultipleInProgress){
	 							setNormal();
	 						}else{
		 						if(parentObj.objectChooser.multipleChecked > 1 || parentObj.userSwitchedManual){
	 							 	if(!parentObj.objectChooser.isMultipleWithLessInProgress){
	 									if(parentObj.confirm(parentObj.msgToNormal)){
	 										parentObj.objectChooser.resetBoleto();
	 										if(parentObj.tramosPriceObj){
	 											parentObj.tramosPriceObj.setUITramo();
	 											parentObj.tramosPriceObj.updateTramoPrize(0);
	 										}else{
		 										parentObj.objectPurchaseOpt.updatePrice(0);
	 										}
	 										parentObj.objectPurchaseOpt.setCanBuy(false)
	 										setNormal();
	 									}
	 								}else{
			 							setNormal();
	 								}
	 							}else{
			 						setNormal();
			 					}
			 				}
 						}else{
	 						setNormal();
					}
				}
 				function setNormal(){
 					setGameMenu(0);
 					if(Foundation.MediaQuery.current=="small" || Foundation.MediaQuery.current=="medium"){
 						parentObj.objectChooser.goToFirstBet();
 					}
	 				switchRandom2Single()
 					parentObj.hidePanels();
					$('[data-boleto]').removeAttr('data-isMultiple data-isReducida data-isCondicionada');
					parentObj.currentMode="normal";
					$('.navBoleto').add('[data-boleto]').removeAttr('data-isCondicionada').removeAttr('data-isReducida')
					if(parentObj.objectChooser.getColumnasCompletadasCache().empty == parentObj.objectChooser.betsPerTicket &&  parentObj.showWizardOnLoad){ //Si no hay nada marcado, lanzamos el wizzard
					 	if(!parentObj.objectChooser.isMultipleWithLessInProgress){
							parentObj.showPanel('wizard')
						}
					}else{
						parentObj.showWizardOnLoad=true;
					}
 	 				if(parentObj.objectChooser.isMultipleWithLessInProgress){
	 					if(parentObj.tramosPriceObj){
	 						parentObj.tramosPriceObj.setUITramo();
	 						parentObj.tramosPriceObj.updateTramoPrize(0);
	 					}else{
		 					parentObj.objectPurchaseOpt.updatePrice(0);
		 				}
	 					parentObj.objectPurchaseOpt.setCanBuy(false);
	 				}
	 				parentObj.objectChooser.isSetToMultiple=false;

	 				if(parentObj.objectChooser.isQuiniela){
						parentObj.objectChooser.isSetToReducida=false;
						parentObj.objectChooser.isSetToCondicionada=false;
		 				$('th[data-columna-extra]').html("<span class='icon-games-elige8' title='elige8'></span>");
		 				$('[data-columna-extra] label').removeClass('disabled ');
		 				$('[data-extraGame]').removeClass('disabled').find('input').removeAttr('disabled')
// 		 				$('[data-columna-extra] label').removeClass('active');
// 	 					$('[data-columna-extra] label input').removeAttr('disabled').prop('checked',false);
	 				}
 				}
				parentObj.userSwitchedManual=false;

 				break;

 				case "multiple":
					if(parentObj.currentMode=="file" && parentObj.fileSent){
						parentObj.resetFileSend();
					}
 					if(parentObj.currentMode!="multiple"){
 						if( (parentObj.currentMode=="normal" || parentObj.currentMode=="wizard")){
 							if( !parentObj.objectChooser.hasBetsAfterFirst || parentObj.objectChooser.isShuffleInProgress){ 	//Completas, sólo 1 (la del múltiple)
 								setMultiple();
 							}else{										//Ya hay alguna apuesta incompleta, o alguna columna rellena y lista. Solicitamos confirmación
 									if(parentObj.confirm(parentObj.msgToMultiple)){
 										parentObj.objectChooser.clearColumnsForMultiple();
 										setMultiple();
 									}else{
 										parentObj.objectChooser.revertClick();
 										setGameMenu(0);
 									}

 							}
 						}else{
 							setMultiple();
 						}
 					}

 					function setMultiple(){
 						setGameMenu(1);
 						if(Foundation.MediaQuery.current=="small" || Foundation.MediaQuery.current=="medium"){
 							parentObj.objectChooser.goToFirstBet();
 						}
	 					switchRandom2Multiple()
 						parentObj.hidePanels();
						$('[data-boleto]').attr('data-isMultiple','true');
						parentObj.currentMode="multiple";

						if(parentObj.objectChooser.isSetToReducida || parentObj.objectChooser.isSetToCondicionada || parentObj.objectChooser.isReducidaInProgress || parentObj.objectChooser.isCondicionadaInProgress){
							parentObj.resetExtraColumns();
 			 				$('[data-columna-extra] label').removeClass('disabled active');
 			 				$('[data-columna-extra] label input').removeAttr('disabled').prop('checked',false);
						}
						parentObj.objectChooser.isSetToMultiple=true;
						parentObj.objectChooser.isSetToReducida=false;
						parentObj.objectChooser.isSetToCondicionada=false;
						parentObj.objectChooser.isReducidaInProgress=false;
						parentObj.objectChooser.isCondicionadaInProgress=false;
						if(!parentObj.objectChooser.isMultipleWithLessInProgress){
							parentObj.resetMultiplesStates();
						}
						$('.navBoleto').add('[data-boleto]').removeAttr('data-isCondicionada').removeAttr('data-isReducida')

						parentObj.hideCloseButton();
						$('[data-boleto_info][data-infoMultiple]').addClass('is-active')
						$('[data-infomultiple] [data-multiplesMode]').removeClass('is-active')
						$('[data-infomultiple] [data-multiplesMode="multiples"]').addClass('is-active')
 	 					if(parentObj.objectChooser.isMultipleWithLessInProgress){
 	 						parentObj.objectChooser.revertClickAction=true;
 	 						$(parentObj.objectChooser.lastPressedElement).trigger('change')
	 	 					$('[data-reducciones-options-1] tr:eq(0)').trigger('click')
						}
						if(!parentObj.objectChooser.isShuffleInProgress){
							parentObj.objectChooser.onClickedMultipleCallback(parentObj.objectChooser); //refrescamos el contenido
						}

	 					if(parentObj.objectChooser.isQuiniela){
		 					$('th[data-columna-extra]').html("<span class='icon-games-elige8' title='elige8'></span>");
							parentObj.objectChooser.onClickedMultipleCallback(parentObj.objectChooser); //refrescamos el contenido
			 				$('[data-extraGame]').removeClass('disabled').find('input').removeAttr('disabled')
// 			 				$('[data-columna-extra] label').removeClass('disabled active');
// 			 				$('[data-columna-extra] label input').removeAttr('disabled').prop('checked',false);
	 					}
 					}
 				break;
				case "reducidas":
					if(parentObj.currentMode=="file" && parentObj.fileSent){
						parentObj.resetFileSend();
					}
 					if(parentObj.currentMode!="reducida"){

 						if(parentObj.currentMode=="normal" || parentObj.currentMode=="wizard" ){
 							if( !parentObj.objectChooser.hasBetsAfterFirst ){ 								//Completas, sólo 1 (la del múltiple)
 								setReducida();
 							}else{										//Ya hay alguna apuesta incompleta, o alguna columna rellena y lista. Solicitamos confirmación
 								if(parentObj.confirm(parentObj.msgToMultiple)){
 									parentObj.objectChooser.clearColumnsForMultiple();
 									setReducida();
 								}else{
 									parentObj.objectChooser.revertClick();
 									setGameMenu(0);
 								}
 							}
 						}else{
 							setReducida();
 						}
 						function setReducida(){
	 						setGameMenu(2);
 							if(Foundation.MediaQuery.current=="small" || Foundation.MediaQuery.current=="medium"){
 								parentObj.objectChooser.goToFirstBet();
 							}
	 						switchRandom2Multiple()
							parentObj.hidePanels();
							$('[data-boleto]').attr('data-isReducida','');
							parentObj.currentMode="reducida";
							parentObj.objectChooser.isReducidaInProgress=true;
							parentObj.objectChooser.isCondicionadaInProgress=false;
							parentObj.objectChooser.isSetToReducida=true;
							parentObj.objectChooser.isSetToCondicionada=false;
							parentObj.resetMultiplesStates();

							$('.navBoleto').add('[data-boleto]').removeAttr('data-isCondicionada').removeAttr('data-isReducida')
							$('.navBoleto').add('[data-boleto]').attr('data-isReducida','')
							$('[data-boleto_info][data-infoMultiple]').addClass('is-active')
// 							$('[data-columna-extra] > span').html("R");
							$('th[data-columna-extra]').html("<span>R</span>");

							parentObj.hideCloseButton();
							$('[data-infomultiple] [data-multiplesMode]').removeClass('is-active')
							$('[data-infomultiple] [data-multiplesMode="reducidas"]').addClass('is-active')

							$("[data-multilpeReducidas]:visible").find("[data-numeroApuestasDirecto]").closest("tr").addClass('is-active')
							parentObj.resetExtraColumns();
							parentObj.initReducidasCombs();
							if(parentObj.objectPurchaseOpt){
	 							if(parentObj.tramosPriceObj){
	 								parentObj.tramosPriceObj.setUITramo();
	 								parentObj.tramosPriceObj.updateTramoPrize(0);
	 							}else{
									parentObj.objectPurchaseOpt.updatePrice(0)
								}
								parentObj.objectPurchaseOpt.setCanBuy(false)
							}
							$('[data-extraGame]').addClass('disabled').find('input').attr('disabled','')
 						}
					}
 				break;
				case "condicionadas":
					if(parentObj.currentMode=="file" && parentObj.fileSent){
						parentObj.resetFileSend();
					}
 					if(parentObj.currentMode!="condicionada"){

 						if(parentObj.currentMode=="normal" || parentObj.currentMode=="wizard" ){
 							if( !parentObj.objectChooser.hasBetsAfterFirst ){ 								//Completas, sólo 1 (la del múltiple)
 								setCondicionadas();
 							}else{										//Ya hay alguna apuesta incompleta, o alguna columna rellena y lista. Solicitamos confirmación
 								if(parentObj.confirm(parentObj.msgToMultiple)){
 									parentObj.objectChooser.clearColumnsForMultiple();
 									setCondicionadas();
 								}else{
 									parentObj.objectChooser.revertClick();
 									setGameMenu(0);
 								}
 							}
 						}else{
 							setCondicionadas();
 						}

 						function setCondicionadas(){
	 						setGameMenu(3);
 							if(Foundation.MediaQuery.current=="small" || Foundation.MediaQuery.current=="medium"){
 								parentObj.objectChooser.goToFirstBet();
 							}
	 						switchRandom2Multiple()
 							parentObj.hidePanels();
							$('[data-boleto]').attr('data-isCondicionada','');
							parentObj.currentMode="condicionada";
							parentObj.resetMultiplesStates();
							parentObj.objectChooser.isReducidaInProgress=false;
							parentObj.objectChooser.isCondicionadaInProgress=true;
							parentObj.objectChooser.isSetToReducida=false;
							parentObj.objectChooser.isSetToCondicionada=true;
							$('.navBoleto').add('[data-boleto]').removeAttr('data-isCondicionada').removeAttr('data-isReducida')
							$('.navBoleto').add('[data-boleto]').attr('data-isCondicionada','')
							$('[data-boleto_info][data-infoMultiple]').addClass('is-active')
							$('th[data-columna-extra]').html("<span>C</span>");

							parentObj.hideCloseButton();
							$('[data-infomultiple] [data-multiplesMode]').removeClass('is-active')
							$('[data-infomultiple] [data-multiplesMode="condicionadas"]').addClass('is-active')

							parentObj.resetExtraColumns();
							parentObj.initCondicionadaColumns();
							if(parentObj.objectPurchaseOpt){
	 							if(parentObj.tramosPriceObj){
	 								parentObj.tramosPriceObj.setUITramo();
	 								parentObj.tramosPriceObj.updateTramoPrize(0);
	 							}else{
									parentObj.objectPurchaseOpt.updatePrice(0)
								}
								parentObj.objectPurchaseOpt.setCanBuy(false)
							}
							$('[data-extraGame]').addClass('disabled').find('input').attr('disabled','')

						}
					}
 				break;
				 case "sendFile":
 					if(parentObj.currentMode!="file"){
						if(parentObj.objectChooser.type == "quiniela"){
							setGameMenu(4);
						} else {
							setGameMenu(2);
						}

	 					switchRandom2Single()
 						parentObj.hidePanels();
						parentObj.currentMode="file";

						parentObj.hideCloseButton();

						$('[data-boleto_info][data-infoFile]').addClass('is-active')
						parentObj.userSwitchedManual=false;
						$('[data-extraGame]').addClass('disabled').find('input').attr('disabled','')
					}
 				break;
 			}
 			if(parentObj.currentMode!="normal" && parentObj.currentMode!="wizard" && parentObj.currentMode!="file"){

 			}
 			function switchRandom2Multiple(){
	 		 	$('[data-quinielacolumn="0"] [data-shuffle]').add('[data-columna] [data-index="0"] [data-shuffle]').attr('data-coreToggle','multRandom').off('click');
	 		 	parentObj.multRandom=new core_dropdown();

 			}

 			function switchRandom2Single(){
	 			if(typeof parentObj.multRandom != "undefined"){
		 			parentObj.multRandom.closeall();
	 			}
	 			$('[data-quinielacolumn="0"] [data-shuffle]').add('[data-columna] [data-index="0"] [data-shuffle]').removeAttr('data-coreToggle');
	 			parentObj.objectChooser.attachRandomEvents();
 			}

 			function setGameMenu(item){
	 			$('#boleto_tabs li').removeClass('is-active');
	 			$('#boleto_tabs li:eq('+item+')').addClass('is-active')
 			}
 		}
 	}
 	boletoInfoPanelPro.prototype.hidePanel = function (panelToHide){
 		switch (panelToHide){
 			case "multiple":
				$('[data-boleto]').removeAttr('data-isMultiple');
				parentObj.hideSetupMultiplePanel();
				parentObj.hideSetupMultipleButton();
 				$('[data-infoMultiple]').removeClass('is-active')

 			break;
 			case "reducida":
				$('[data-boleto]').removeAttr('data-isReducida');
				parentObj.hideSetupMultiplePanel();
				parentObj.hideSetupMultipleButton();
 				$('[data-infoMultiple]').removeClass('is-active')
 			break;
 			case "condicionada":
				$('[data-boleto]').removeAttr('data-isCondicionada');
				parentObj.hideSetupMultiplePanel();
				parentObj.hideSetupMultipleButton();
 				$('[data-infoMultiple]').removeClass('is-active')

 			break;
 			case "wizard"://normal
 				$('[data-boleto_info][data-infoWizard]').removeClass('is-active')
 			break;
 			case "sendFile":
 				$('[data-boleto_info][data-infoFile]').removeClass('is-active')
 			break;
 		}

 	}


 	boletoInfoPanelPro.prototype.hidePanels = function (options){
 		$('[data-boleto_info]').removeClass('is-active')
 	}

  	boletoInfoPanelPro.prototype.hideCloseButton = function (){
 		$('[data-boleto_info] .close-button').fadeOut();
	}
  	boletoInfoPanelPro.prototype.showCloseButton = function (){
 		$('[data-boleto_info] .close-button').fadeIn();
 	}
 	boletoInfoPanelPro.prototype.initCondicionadaColumns = function (){
		parentObj.objectChooser.setMultipleRawValues({
			"variantes":0,
			"equis":0,
			"doses":0,
			"apuestas":0
		})
		$("[data-condicionadas-apuestas]").empty().removeAttr('data-condicionadas-condiciones');
	 	if(parentObj.tramosPriceObj){
	 		parentObj.tramosPriceObj.setUITramo(0);
	 		parentObj.tramosPriceObj.updateTramoPrize(0);
	 	}else{
			myPurchaseOptions.updatePrice(0);
		}
		myPurchaseOptions.setCanBuy(false);
	 	function checkCondicionesValues(){
			if( $("[name='variantes']").parent("label.is-active").length==0 || $("[name='equis']").parent("label.is-active").length==0 || $("[name='doses']").parent("label.is-active").length==0){
				$('[data-button-calcula-condicionadas]').attr('disabled','').addClass('disabled');
				parentObj.callbackOnUnavailableCondicionadas(parentObj);
			}else{
				$('[data-button-calcula-condicionadas]').removeAttr('disabled').removeClass('disabled');
				parentObj.callbackOnAvailableCondicionadas(parentObj);
			}
// 			console.log(parentObj.currentMode)
			if(parentObj.currentMode=="condicionada"){
				parentObj.objectChooser.setMultipleRawValues({
					"variantes":0,
					"equis":0,
					"doses":0,
					"apuestas":0
				})
				$("[data-condicionadas-apuestas]").empty().removeAttr('data-condicionadas-condiciones');
	 			if(parentObj.tramosPriceObj){
	 				parentObj.tramosPriceObj.setUITramo(0);
	 				parentObj.tramosPriceObj.updateTramoPrize(0);
	 			}else{
					myPurchaseOptions.updatePrice(0);
				}
				myPurchaseOptions.setCanBuy(false);
			}
	 	}

		$("[name='variantes']").add("[name='equis']").add("[name='doses']").off("change").on("change",function(){
			checkCondicionesValues();
		})

		if(parentObj.currentMode=="condicionada" || parentObj.currentMode=="reducida" ){

			$("tbody [data-quinielacolumn='0']").each(function(){
				var row=$(this).closest('tr').attr('data-row');
				if($(this).find('[data-value] input:checked').length<2){

					var condBtElem=$('tr[data-row="'+row+'"] [data-columna-extra] label');
					$('tr[data-row="'+row+'"] [data-columna-extra] label').addClass('disabled').find('input').attr('disabled','')
					if($(condBtElem).hasClass('active')){
						$(condBtElem).click();
					}
				}else{
					$('tr[data-row="'+row+'"] [data-columna-extra] label').removeClass('disabled').find('input').removeAttr('disabled','');
				}
				$("tbody [data-quinielacolumn='0'] input").off('change.condicionadasEvents').on('change.condicionadasEvents',function(){
					var row=$(this).closest('tr').attr('data-row');
					var condBtElem=$('tr[data-row="'+row+'"] [data-columna-extra] label');
					if( $(this).closest('td').find('label input:checked').length<2){
						if($(condBtElem).hasClass('active')){
							$(condBtElem).click();
						}
						$(condBtElem).addClass('disabled').find('input').attr('disabled','');
					}else{
						$(condBtElem).removeClass('disabled').find('input').removeAttr('disabled','');

					}
					checkCondicionesValues();

				})
			})

		}else{
			$("tbody [data-quinielacolumn='0'] input").off('change.condicionadasEvents');
		}
	}
 	boletoInfoPanelPro.prototype.resetExtraColumns = function (){
		$("tbody [data-quinielacolumn='0'] input").off('change.condicionadasEvents');
		parentObj.objectChooser.resetExtraColumns();
		parentObj.objectChooser.setMultipleRawValues({
			"variantes":0,
			"equis":0,
			"doses":0,
			"apuestas":0
		})
		$("[data-condicionadas-apuestas]").empty()
		$('[data-infoMultiple]:visible [name="variantes"]').add('[data-infoMultiple]:visible [name="equis"]').add('[data-infoMultiple]:visible [name="doses"]').prop({'checked':false,'disabled':'disabled'}).closest('label').removeClass('is-active').addClass('disabled')
		$("[data-condicionadas-apuestas]").empty().removeAttr('data-condicionadas-condiciones');

	}
 	boletoInfoPanelPro.prototype.initReducidasCombs = function (){
		$("[data-reducciones-oficiales-options-1] tr:eq(0)").hide();
 		parentObj.initCondicionadaColumns()
	}
	boletoInfoPanelPro.prototype.resetMultiplesStates=function(){

// 		$("[data-reducciones-options-2]").html("");
		$("[data-customMultiple]").addClass("disabled").removeClass('is-active');
		$("[data-customMultiple]").attr("disabled", "false");
		$('[data-formulasHelp]').removeClass('is-active');

		$("[data-reducciones-options-1] tr:eq(0)").add($("[data-reducciones-options-2] tr:eq(0)")).add('[data-reducciones-oficiales-options-1] tr').add('[data-reducciones-oficiales-options-2] tr').addClass("disabled").removeClass('is-active');
		$("[data-reducciones-options-1] tr:eq(0)").show();
		if(!this.currentMode == "multiple"){

		}else{
			if(!parentObj.objectPurchaseOpt.isMultipleInProgress){

				$("[data-dineroDirecto]").html("???");
				$("[data-numeroapuestasdirecto]").html("???");
				$("[data-select-personalizada-numero]").html("");
				$("[data-select-personalizada-apuestas]").html("");
				$("[data-reducciones-option]").remove();

				$("[data-reducciones-options-1] tr ").removeClass('is-active').addClass('disabled').find('input').attr('disabled','disabled');
				$("[data-customMultiple] label").removeClass('is-active').find('input').prop('checked',false);
			}
		}
		if(this.currentMode == "reducida"){
			$("[data-reducciones-oficiales-options-1] tr").add('[data-reducciones-oficiales-options-2] tr').removeClass("disabled").attr('disabled','disabled');
			$("[data-reducciones-oficiales-options-1] tr:eq(0)").removeClass('disabled').removeAttr('disabled')
		}



		if(!this.objectChooser.isSetToMultiple){
			$('[data-boleto]').removeAttr('data-isMultiple');
		}else{
			$('[data-boleto]').attr('data-isMultiple',false);
		}


		if(!this.objectChooser.isCondicionada){
			$('[data-boleto]').removeAttr('data-isCondicionada');
		}else{
			$('[data-boleto]').attr('data-isCondicionada',false);
		}

		if(!this.objectChooser.isSetToCondicionada){
			$('[data-boleto]').removeAttr('data-isReducida');
		}else{
			$('[data-boleto]').attr('data-isReducida',false);
		}


		if(this.currentMode=="multiple"){
			$('[data-boleto]').attr('data-isMultiple',"true");
		}else if(this.currentMode=="reducida"){
			$('[data-boleto]').attr('data-isMultiple',"true");
			$('[data-boleto]').attr('data-isReducida',"");
		}else if(this.currentMode=="condicionada"){
			$('[data-boleto]').attr('data-isMultiple',"true");
			$('[data-boleto]').attr('data-isCondicionada',"");
		}

		if(this.currentMode =="reducida" || this.currentMode == "condicionada"){
			parentObj.resetExtraColumns();
		}
		parentObj.initCondicionadaColumns();
	 	if(parentObj.tramosPriceObj){
	 		parentObj.tramosPriceObj.setUITramo();
	 		parentObj.tramosPriceObj.updateTramoPrize(0);
	 	}else{
			parentObj.objectPurchaseOpt.updatePrice(0)
		}
		parentObj.objectPurchaseOpt.setCanBuy(false)

	}
	boletoInfoPanelPro.prototype.confirm=function(confirmMsg){
		return confirm(confirmMsg);
	}
	boletoInfoPanelPro.prototype.setCustomOffers = function(reduccionObj){
		//reduccionObj -> {reduccionId: "348", reduccion: "3", apuestas: "86", nums: "19"}

		var self=this;
		var dobles=0;
		var triples=0;
		self.objectChooser.setAllowMultiple(true);
		if(!self.objectChooser.isQuiniela){
			self.objectChooser.setRandom(0,{
				custom:{
					nums:reduccionObj.numeros,
					reduccionId:reduccionObj.reduccionId,
					reduccion:reduccionObj.reduccion
				}
			})
		}else{
			var numsString=reduccionObj.numeros.toString();
			if(numsString.length!=3){
				dobles=reduccionObj.numeros;
			}else{
				triples=parseInt(numsString.substr(0,1));
				dobles=parseInt(numsString.substr(1,2));
			}
			self.objectChooser.setRandom(0,{
				custom:{
					deDos:dobles,
					deTres:triples,
					reduccionId:reduccionObj.reduccionId,
					reduccion:reduccionObj.reduccion

				}
			})
	}

}
	boletoInfoPanelPro.prototype.setBlink = function(state){
		if(state){
			$('[data-btplaymultiple]').addClass('animated fadeBlink');
		}else{
			$('[data-btplaymultiple]').removeClass('animated fadeBlink');
		}
	}

	boletoInfoPanelPro.prototype.renderAssistant = function(injectTo,avatar,alignment){
			let show = null;
			if(typeof avatar != "undefined" && avatar !== false){
				this.avatarImg = avatar;
			}
			if(typeof getCookie != "undefined"){
				show = getCookie('turrerBot_show') ?? null;
				if(show && show == "noload"){
					this.injectHelper()
					return false;
				}else if(show && show == "false"){
					this.injectHelper()
					show = false;
				}else{
					show = true;
				}
			}else{
				show = true;
			}
			if( $(injectTo).find(`[${this.assistantSelectorAttr}]`).length  > 0){
				$(injectTo).find(`[${this.assistantSelectorAttr}]`).remove();
			}
			var self = this;
			var align = alignment ?? (alignment == "right" || alignment == "left") ? alignment : "";
			let hideStatus = !show ? `style="display:none"` : ``;
			var html = `<div ${this.assistantSelectorAttr} class="${align}" ${hideStatus}>`;
			/* var html = "<div class='mini' "+this.assistantSelectorAttr+">"; */
			if(typeof avatar != "undefined" && avatar !== false){
				this.avatarImg = avatar;
				html = html + '<button type="button" data-action><span data-assistant-status></span><img src="'+avatar+'"></button>';
			}
			html = html + '<span data-assistantMsg><span data-assistantText></span></span><button type="button" data-close-assistant></button><button type="button" data-reset-assistant></button>';
			$(html).appendTo(injectTo);
			var el = $(`[${this.assistantSelectorAttr}]`);
			var containment = "body"
			var middlepoint = $('body').outerWidth()/2;
			let bt = $(el).find('[data-action]');
			var startX = $(bt).position().left + ($(bt).width() / 2);
			var startY = $(bt).position().top + ($(bt).height() / 2);
			bamQueue.waitForExistance("$.ui",() => {
				$( "[data-helpassistant]").draggable({
					cancel: "",
					handle:"button",
					cursorAt: { left: startX, top:startY },
					start: function( event, ui ) {
						//self.showAssistant();
						var bt = $(el).find('button[data-action]');
						$(el).find('button[data-action]').off('click');
						$(el).attr('dragged',true)
					},
					stop: function( event, ui){
						var bt = $(el).find('button[data-action]');
						$(bt).trigger('mouseOut')
						if(ui.offset.left > middlepoint){
							if ($(el).hasClass('right')) $(el).data('hasRight',true)
							$(el).removeClass('right')
						}else{
							if( $(el).data('hasRight') != undefined ) $(el).addClass('right')
						}
						setTimeout(() => {
							$(bt).on('click',() => { self.switchAssistant()});
							self.setSafeBoundaries();
						},100)
					}
				});
				if(!Foundation.MediaQuery.is('small') && !Foundation.MediaQuery.is('medium')){
					$( "[data-helpassistant]").draggable("option","containment",containment);
				}else{
					$( "[data-helpassistant]").draggable("option","containment",false);
				};

				$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
					if(newSize == "small" || newSize == "medium"){
						$( "[data-helpassistant]").draggable("option","containment",false);
					}else{
						$( "[data-helpassistant]").draggable("option","containment",containment);
					};
				});
			});
			$(el).find('button[data-action]').off('click').on('click', (e) => {
				this.switchAssistant()
			})
			$(el).find('button[data-reset-assistant]').off('click').on('click', (e) => {
				this.resetAssistant();
			})
			$(el).find('button[data-close-assistant]').off('click').on('click', (e) => {
				this.closeAssistant();
			})

			this.parseInitialConfig();

	}
	boletoInfoPanelPro.prototype.parseInitialConfig = function(){

		if(typeof getCookie != "undefined"){
			let turrerBot_x = getCookie('turrerBot_x') ?? null;
			let turrerBot_y = getCookie('turrerBot_y') ?? null;
			let turrerBot_mini = getCookie('turrerBot_mini') ?? false;
			let turrerBot_show = getCookie('turrerBot_show') ?? true;
			let elem = $(`[${this.assistantSelectorAttr}]`);
			if(turrerBot_y && !isNaN(turrerBot_y) || turrerBot_x && !isNaN(turrerBot_y)){
				$(elem).attr('dragged',true);
				if(turrerBot_x) $(elem).css('left',`${turrerBot_x}px`);
				if(turrerBot_y) $(elem).css('top',`${turrerBot_y}px`);
			}
			turrerBot_mini && turrerBot_mini =="true" ? this.hideAssistant() : this.showAssistant();
		}
	}
	boletoInfoPanelPro.prototype.switchAssistant = function(){
		let elem = $(`[${this.assistantSelectorAttr}]`);
		if(elem.hasClass('is-active')){
			this.hideAssistant();
		}else{
			this.showAssistant();
		}
	}

	boletoInfoPanelPro.prototype.dragged = function(){
		let elem = $("["+this.assistantSelectorAttr+"]");
		if(typeof $(elem).attr('dragged') != "undefined") return true;
		return false;
	}

	boletoInfoPanelPro.prototype.showAssistant = function(){
		var self = this;
		$("["+this.assistantSelectorAttr+"]").addClass('is-active');
		self.setSafeBoundaries();
		if(typeof setCookie != "undefined"){
			setCookie('turrerBot_mini',false,30);
			setCookie('turrerBot_show',true,30);

		}
	}

	boletoInfoPanelPro.prototype.hideAssistant = function(){
		var elem = $("["+this.assistantSelectorAttr+"]");
		if(!this.dragged()){
			return false
		}
		$(elem).removeClass('is-active');
		if(typeof setCookie != "undefined"){
			setCookie('turrerBot_mini',true,30);
		}
	}

	boletoInfoPanelPro.prototype.resetAssistant = function(){
		var elem = $("["+this.assistantSelectorAttr+"]");
		$(elem).removeAttr('dragged');
		$(elem).css('top','0px')
		$(elem).css('left','0px')
		setCookie('turrerBot_x',"false",30);
		setCookie('turrerBot_y',"false",30);
		this.showAssistant();
	}

	boletoInfoPanelPro.prototype.setSafeBoundaries = function(referenceElem = "body",allowCookie = true){
		let elem = $("["+this.assistantSelectorAttr+"]");
		let ref = $(referenceElem)[0].getBoundingClientRect()
		let offset = 5;
		if($(elem).length > 0){
			let bound = $(elem)[0].getBoundingClientRect();
			if(bound.left < ref.left){
				$(elem).css('left',`${ref.left + offset}px`);
			}
			if(bound.right > ref.right){
				$(elem).css('left',`${ref.width - offset - bound.width}px`);
			}
			if((bound.top - Math.abs(ref.top)) <= ref.top){
				$(elem).css('top',`${offset}px`);
			}
			let heightScrolledOffset = ref.height - ref.bottom;
			if(bound.bottom + heightScrolledOffset >= ref.height + heightScrolledOffset){
				$(elem).css('top',`${ref.height - bound.height - offset}px`);
			}
			if(allowCookie && typeof setCookie != "undefined" && typeof $(elem).attr('dragged') != "undefined"){
				setCookie('turrerBot_x',parseInt($(elem).css('left')),30);
				setCookie('turrerBot_y',parseInt($(elem).css('top')),30);
			}
		}
	}

	boletoInfoPanelPro.prototype.closeAssistant = function(remove = false){
		let elem = $("["+this.assistantSelectorAttr+"]");
		if(remove){
			$(elem).remove();
			if(typeof setCookie != "undefined"){
				setCookie('turrerBot_show','noload',30);
			}
		}else{
			$(elem).hide();
			if(typeof setCookie != "undefined"){
				setCookie('turrerBot_show',false,30);
			}
		}
		this.injectHelper();
	}
	boletoInfoPanelPro.prototype.openAssistant = function(){
		let elem = $("["+this.assistantSelectorAttr+"]");
		this.resetAssistant();
		this.showAssistant();
		$(elem).show();
		this.removeHelper();
	}
	boletoInfoPanelPro.prototype.injectHelper = function(){
		let avatarHTML = "";
		this.avatarImg ? avatarHTML = `<img src="${this.avatarImg}">` : avatarHTML = "";

		let html = `<button type="button" data-assistant-invoquer>${avatarHTML}</button>`;
		if( $('[data-boleto_infobox] [data-jornadainfo]').find('[data-assistant-invoquer]').length == 0){
			$('[data-boleto_infobox] [data-jornadainfo]').append(html)
		}
		$('[data-boleto_infobox] [data-jornadainfo]').find('[data-assistant-invoquer]').off('click').on('click', (e) => { this.openAssistant()} )
	}
	boletoInfoPanelPro.prototype.removeHelper = function(){
		let el = $('[data-boleto_infobox] [data-jornadainfo]').find('[data-assistant-invoquer]')
		$(el).remove()
	}
	boletoInfoPanelPro.prototype.unsetAssistantMsg = function(){
		$("["+this.assistantSelectorAttr+"] [data-assistantMsg] [data-assistantText]").empty();
	}

	boletoInfoPanelPro.prototype.setAssistantMsg = function(message,secondsToStay){
		var self = this;
		var mensaje = message;

		$("["+self.assistantSelectorAttr+"] [data-assistantMsg] [data-assistantText]").html(mensaje);
		if(typeof secondsToStay != "undefined" && secondsToStay !== false){
			setTimeout(function(){
				self.hideAssistant();
			}, secondsToStay*1000)
		}
	}
	boletoInfoPanelPro.prototype.disableAssistant = function(){
		let el = $(`[${this.assistantSelectorAttr}]`);
		$(el).hide();
	}
	boletoInfoPanelPro.prototype.enableAssistant = function(){
		let el = $(`[${this.assistantSelectorAttr}]`);
		$(el).show();
	}
}

//********************************************************************************************
function calculaCondicionadas(choserObj, options, tramosPriceObj){

	var variantes = new Array();
	var equis = new Array();
	var doses = new Array();

	var strings = {
		bets: "apuestas",
		processing: "caculando"
	}

	if(typeof options != "undefined"){
		if (options.strings != "undefined"){
			if (options.strings.bets != "undefined") { strings.bets = options.strings.bets}
			if (options.strings.processing != "undefined") { strings.processing = options.strings.processing}
		}
	}

	$("[name='variantes']").parent('label.is-active').each(function(){ variantes.push(parseInt($(this).find('input').attr('data-value'))) })
	$("[name='equis']").parent('label.is-active').each(function(){ equis.push(parseInt($(this).find('input').attr('data-value'))) })
	$("[name='doses']").parent('label.is-active').each(function(){ doses.push(parseInt($(this).find('input').attr('data-value'))) })

	choserObj.setMultipleRawValues({
		"variantes":variantes,
		"equis":equis,
		"doses":doses,
	})
	var valoresCondicionadas=choserObj.getRawValues({ 'exportForCondicionadas':true});

	var formElem=$("#condicioCalc");
	var submitCondicionadas = new formeSubmit( $(formElem),"/data/?action=quinielamultiple",
	{
		extraFields: { "combinacion": valoresCondicionadas[0], "condiciones": valoresCondicionadas["condiciones"]},
		submitBt: {
			holdMsg: "..."+strings.processing,
			enableOnSuccess:true
		},
		callbackOnSuccess: function(e) {
			$("[data-condicionadas-apuestas]").html(e.data + " "+strings.bets).attr("data-condicionadas-condiciones", valoresCondicionadas["condiciones"]);
			if(e.data>=2){
				choserObj.setMultipleRawValues({
					"variantes":variantes,
					"equis":equis,
					"doses":doses,
					"apuestas":e.data
				})
				if(typeof tramosPriceObj != "undefined"){
					tramosPriceObj.setUITramo(parseInt(e.data),myPurchaseOptions.dias,myPurchaseOptions.semanas);
					tramosPriceObj.updateTramoPrize(parseInt(e.data),myPurchaseOptions.dias,myPurchaseOptions.semanas);
				}else{
					myPurchaseOptions.updatePrice(e.data);
				}
				myPurchaseOptions.setCanBuy(true);
			}else{
				choserObj.setMultipleRawValues({
					"variantes":variantes,
					"equis":equis,
					"doses":doses,
					"apuestas":0
				})
				$("[data-condicionadas-apuestas]").html("0 "+strings.bets);
				if(typeof tramosPriceObj != "undefined"){
					tramosPriceObj.setUITramo(0);
					tramosPriceObj.updateTramoPrize(0);
				}else{
					myPurchaseOptions.updatePrice(0);
				}
				myPurchaseOptions.setCanBuy(false);
			}
		},
		callbackOnFail: function(e) {
		$("[data-condicionadas-apuestas]").html("");
			choserObj.setMultipleRawValues({
				"variantes":variantes,
				"equis":equis,
				"doses":doses,
				"apuestas":0
			})
			if(typeof tramosPriceObj != "undefined"){
				tramosPriceObj.setUITramo(0);
				tramosPriceObj.updateTramoPrize(0);
			}else{
				myPurchaseOptions.updatePrice(0);
			}
			myPurchaseOptions.setCanBuy(false);
		}
	} );
}
function retrieveBetsUrl(betsObj,callback){ //funcion que pasa un objeto apuesta, y devuelve la URL compuesta
	var successCallback=function(){};
	if(typeof callback != "undefined"){
		successCallback = callback;
	}
	var returnValue=false;

	var options={
			extraFields: { "bets":encodeURI(JSON.stringify(betsObj))},
			callbackOnSuccess:function(e){
				if(e.data != "undefined"){
					var urlSplit = (e.data).split("?");
					returnValue = urlSplit[1]
				}
				successCallback(returnValue);

			},
			callbackOnFail:function(){
				return false;
			},
			redirectURL: false
		}
	myForm = new formeSubmit(false,"/data/?action=retrieveBetsUrl",options);
}
function parseBetByGet(chooserObj,purchaseObj,boletoInfoObj,options){
	var getObj={}
	var getUrl=window.location.search.substr(1)
	var mode="";
	var manualQueryStringInput=false;

	//DEBUG
	//getUrl="modo=directo&combinaciones=22,24,25,42,43-3,13,33,43,42-&abono=&semanas=1&semanal=&dias=1";
	//getUrl="modo=directo&combinaciones=22,24,25,42,43~1,2-3,13,33,43,42~1,2,3-&abono=&semanas=1&semanal=&dias=1";

	//getUrl="modo=multiple&combinaciones=X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X,X,12M,2M&abono=&semanas=1&semanal=&dias=1
	//getUrl="modo=multiple&combinaciones=X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X2,X,X,12M,2M&abono=&semanas=1&semanal=&dias=1&reduccion=1514&optimizadaAl=13 //formulas, y formulas personalizadas
	//getUrl="modo=multiple&combinaciones=12,12,12,X2,X2,X2,X2,X2,X2,X2,X2,X2,X,X,12M,2M&abono=&semanas=1&semanal=&dias=1&condiciones=1,2,3-0-0,-0 //condicionales y reducidas

	//-----
	//Si viene en base 64: ?params=cadenaenbase64

	if(typeof options != "undefined"){
		if(typeof options.manualQueryStringInput != "undefined"){
			manualQueryStringInput = options.manualQueryStringInput;
			getUrl=manualQueryStringInput
		}
	}

	if(getUrl.indexOf("params=") != -1){
		//Está codificado en base64
		var valSplit = getUrl.split("params=");
		var urlStr = $.base64.decode(valSplit[1]);//window.atob(valSplit[1]);
		var urlSplit = urlStr.split("&");
	}else{
		//No lo está, formato antiguo
		var urlSplit = getUrl.split("&");
	}

	$(urlSplit).each(function(key,value){
		var valSplit=value.split("=");
		getObj[valSplit[0]]=valSplit[1];
		if(typeof valSplit[1]!="undefined" && valSplit[1].trim().length==0){
			getObj[valSplit[0]]=false;
		}
	})


	if(typeof getObj.combinaciones!="undefined" && getObj.combinaciones){
		var combinaciones=getObj.combinaciones.split("-");
		var combinacion=new Array();
		i=0;
		$(combinaciones).each(function(){
			if(this.trim().length>0){
				var combObj={}
				var numsYextras=this.split("~");
				if(typeof numsYextras[0] != "undefined" && numsYextras[0].length>0){
					combObj["nums"]=cleanArray(numsYextras[0].split(","));
				}
				if(typeof numsYextras[1] != "undefined" && numsYextras[1].length>0){
					combObj["extras"]=cleanArray(numsYextras[1].split(","));
				}
				combinacion.push(combObj);
			}
		})

		//Si es quiniela convertimos el primer elemento en un array
		if(chooserObj.isQuiniela && combinacion.length>0){
			$(combinacion[0]["nums"]).each(function(key,value){
				combinacion[0]["nums"][key]=value.split('');
			})
		}

		if(typeof getObj.elige8!="undefined"){
 			combinacion[0]["elige8"]=getObj.elige8.split(",");
		}

		if(typeof getObj.reintegro!="undefined"){
 			combinacion[0]["reintegro"]=getObj.reintegro;
		}

		if(typeof getObj.joker!="undefined" && getObj.joker==1){
 			combinacion[0]["joker"]=1;
		}
		if(typeof getObj.randomAbono!="undefined" && getObj.randomAbono==1){
		}
		if(typeof getObj.reduccion!="undefined"){
			reduccion="directo";
			combinacion[0]["idReduccion"]=getObj.reduccion;
		}else{
			reduccion="directo";
			combinacion[0]["idReduccion"]=reduccion;
		}

		if(typeof getObj.optimizadaAl!="undefined"){
			combinacion[0]["optimizadaAl"]=getObj.optimizadaAl;
		}

		if(typeof getObj.condiciones!="undefined"){
			var condicionesArray = getObj.condiciones.split("-");
			var condicionadas = condicionesArray[0].split(",");
			combinacion[0]["condicionadas"]=condicionadas;
			if(typeof condicionesArray[1]!="undefined" && typeof condicionesArray[2]!="undefined" && typeof condicionesArray[3]!="undefined" ){
				var variantes = condicionesArray[1].split(",");
				var doses = condicionesArray[2].split(",");
				var equis = condicionesArray[3].split(",");
				combinacion[0]["variantes"]=variantes;
				combinacion[0]["doses"]=doses;
				combinacion[0]["equis"]=equis;
			}
		}

		if(typeof getObj.abono!="undefined"){
			if(getObj.abono=="1"){
				if(typeof getObj.abonoRandom!="undefined"){
					if(getObj.abonoRandom=="1"){
						purchaseObj.setRenew(true,true);
					}else{
						purchaseObj.setRenew(true,false);
					}
				}else{
					purchaseObj.setRenew(true,false);
				}
			}else{
				purchaseObj.setRenew(false,false);
			}
		}else{
			purchaseObj.setRenew(false,false);
		}


		if(typeof getObj.semanas!="undefined"){
			purchaseObj.setSemanas(parseInt(getObj.semanas));
		}

		if(typeof getObj.dias!="undefined"){
			purchaseObj.setSorteos(getObj.dias.split(","))
		}

/* 		purchaseObj.setDays() */
		boletoInfoObj.initCondicionadaColumns();
		chooserObj.setBet(combinacion)
		if(chooserObj.progressiveColumns){
			chooserObj.unblockAllColumns();
			chooserObj.purgeEmptyColumns();
		}
// 		parentObj.boletoSnapshot[numbersIndex].status = 1;
	}else{
		return false;
	}

	// Will remove all falsy values: undefined, null, 0, false, NaN and "" (empty string)
	function cleanArray(actual) {
	  var newArray = new Array();
	  for (var i = 0; i < actual.length; i++) {
	    if (actual[i]!="") {
	      newArray.push(actual[i]);
	    }
	  }
	  return newArray;
	}
}
function retrieveReduccionesData(reduccionesObj,reduccionId,numApuestas){
	var obj={}

	$(reduccionesObj[numApuestas]).each(function(){
		if(this.id==reduccionId){
			obj.reduccionId=reduccionId;
			obj.apuestas=this.apuestas;
			obj.reduccion=this.reduccion;
			obj.numeros=this.numeros;
		}
	})

	return obj;
}
function multipleSelectionSelects(objectPurchaseOption, arrayPersonalizadas,chooserObj,tramosPriceObj) {

	$("[data-select-personalizada-numero]").off('click').on("change", function() {
		console.log("wa")
		$("[data-select-personalizada-apuestas]").html("");
		var element = arrayPersonalizadas[$(this).val()];
		if(typeof tramosPriceObj != "undefined"){
			var priceValueBeforeDiscount = objectPurchaseOption.setPrice(tramosPriceObj.precioPorDefecto,parseInt(apuestas),false);
			appendSelectOfApuestas(element, objectPurchaseOption);
			tramosPriceObj.setUITramo(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
			tramosPriceObj.updateTramoPrize(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
		}else{
			appendSelectOfApuestas(element, objectPurchaseOption);
			objectPurchaseOption.updatePrice(apuestas);
		}

		var apuestas=$("[data-select-personalizada-apuestas]").val()
		updatePercentages(5, $("[data-select-apuestasId='" + apuestas + "']"));

		chooserObj.setMultipleRawValues({ "apuestas":apuestas});
	});

	$("[data-select-personalizada-apuestas]").off('click').off('change').on("change", function() {
		console.log("we")
		var precioTotal = objectPurchaseOption.calculatePrice($(this).val(),true);
		var apuestas=$("[data-select-personalizada-apuestas]").val()
		updatePercentages(5, $("[data-select-apuestasId='" + apuestas + "']"));

		var priceValueAfterDiscount = $("[data-precioPersonalizada]").html()

		if(typeof tramosPriceObj != "undefined"){
			var priceValueBeforeDiscount = objectPurchaseOption.setPrice(tramosPriceObj.precioPorDefecto,parseInt(apuestas),false);
			if(typeof global_currency == "undefined"){
				$("[data-precioPersonalizada]").html( objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2) + "€" );
			}else{
				$("[data-precioPersonalizada]").html( global_currency.getMoneda(parseFloat(objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2))) );
			}
			tramosPriceObj.setUITramo(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
			tramosPriceObj.updateTramoPrize(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
		}else{
			if(typeof global_currency == "undefined"){
				$("[data-precioPersonalizada]").html( objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2) + "€" );
			}else{
				$("[data-precioPersonalizada]").html( global_currency.getMoneda(parseFloat(objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2))) );
			}
			objectPurchaseOption.updatePrice(apuestas);
		}
		var idPersonalizadas=$(this).find('option:selected').attr("data-reducciones-id");
		if(typeof idPersonalizadas!="undefined"){
			chooserObj.setMultipleRawValues({ "idReduccion":idPersonalizadas,"apuestas":apuestas});
		}
	});

}
function appendSelectOfApuestas(element,objectPurchaseOption,tramosPriceObj) {
	for (var i=0;i<element.length;i++) {
		var elementToAppend = "<option data-reducciones-id='"+element[i]["id"]+"' data-select-apuestasId='" + element[i]["apuestas"] + "' value='" + element[i]["apuestas"] + "' data-cat1='" + element[i]["cat1"] + "' data-cat2='" + element[i]["cat2"] + "' data-cat3='" + element[i]["cat3"] + "' data-cat4='" + element[i]["cat4"] + "'' data-cat5='" + element[i]["cat5"] + "'>" + element[i]["apuestas"] + "</option>";
		$("[data-select-personalizada-apuestas]").append(elementToAppend);
	}
	var apuestas = $("[data-select-personalizada-apuestas]").val();
	if(typeof tramosPriceObj != "undefined"){
		var priceValueBeforeDiscount = objectPurchaseOption.setPrice(tramosPriceObj.precioPorDefecto,parseInt(apuestas),false);
			if(typeof global_currency == "undefined"){
				$("[data-precioPersonalizada]").html( objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2) + "€" );
			}else{
				$("[data-precioPersonalizada]").html( global_currency.getMoneda(parseFloat(objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2))) );
			}
		tramosPriceObj.setUITramo(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
		tramosPriceObj.updateTramoPrize(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
	}else{
		if(typeof global_currency == "undefined"){
			$("[data-precioPersonalizada]").html(objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2) + "€");
		}else{
			$("[data-precioPersonalizada]").html( global_currency.getMoneda(parseFloat(objectPurchaseOption.calculatePrice(apuestas,true).toFixed(2))));
		}
	}
}
function multipleSelectionTable(objectPurchaseOption,chooserObj,tramosPriceObj){ //Eventos asociados a los clicks en filas para las selecciones de múltiples
	var self=this;
	$('[data-multiplesummary] tr').off('click').on('click',function(){
		if (!$(this).hasClass("disabled")) {
		$(this).find('input[type=radio]').click();
		}
	});

	$('[data-multiplesummary] input[type=radio]').off('click').on('click',function(event) {
		event.stopPropagation();

		if ($(this).closest("tr").attr("disabled") === undefined) {
			if (typeof $(this).closest("tr").attr("data-custommultiple") === "undefined" || typeof $(this).closest("tr").attr("disabled") === "undefined") {
				if(typeof $(this).closest("tr").attr('data-reducciones-option') != "undefined" || typeof $(this).closest("tr").attr('data-custommultiple') != "undefined"){
					$('[data-formulasHelp]').addClass('is-active');
				}else{
					$('[data-formulasHelp]').removeClass('is-active');
				}

				$('[data-multipletypes] tr').removeClass('is-active');
				$('[data-multipletypes] label').removeClass('is-active');
				$(this).closest('tr').addClass('is-active');
				$(this).closest('label').addClass('is-active')
				if (typeof $(this).closest("tr").attr("data-custommultiple") === "undefined") {
					updatePercentages(5, $(this).closest("tr"));
					var apuestas=0;
					//Comprobamos si hay elige 8
					var elige8 = false;
					var apuestasElige8 = 0;
					var precioElige8 = 0;
					if((!chooserObj.isReducidaInProgress && !chooserObj.isCondicionadaInProgress && !chooserObj.isSetToCondicionada && !chooserObj.isSetToReducida) && (chooserObj.isMultipleInProgress || chooserObj.isSetToMultiple) && (typeof chooserObj.rawApuesta["elige8"] != "undefined" && chooserObj.rawApuesta["elige8"].length == chooserObj.extrasToChooseSN)){
						elige8 = true;
						if(typeof $(this).closest("tr").attr("data-numeroApuestaselige8") != "undefined"){
							apuestasElige8 = parseInt($(this).closest("tr").attr("data-numeroApuestaselige8"))
						}
						if(typeof $(this).closest("tr").attr("data-precioElige8") != "undefined"){
							precioElige8 = parseFloat($(this).closest("tr").attr("data-precioElige8"))
						}
					}else{
						elige8 = false;
					}

					if(typeof $(this).closest("tr").attr("data-numeroApuestastotal") !="undefined"){
						apuestas=parseInt($(this).closest("tr").attr("data-numeroApuestastotal"))*parseInt($(this).closest("tr").attr("data-numeroApuestas"));
					} else {
						apuestas=$(this).closest("tr").attr("data-numeroApuestas");
					}
					if(typeof tramosPriceObj != "undefined"){
						var precioApuestasNormales = tramosPriceObj.getDefaultPrice() * apuestas;
						var precioElige8Total = apuestasElige8 * precioElige8;
						var jornadas = 1;
						if(elige8){
							objectPurchaseOption.setAdditionalGame(true,{ "game":"elige8","precio":precioElige8,"bets":apuestasElige8});
// 							updatePriceLabels(null,parseFloat(precioApuestasNormales+precioElige8Total).formatMoney(2, ".", ""),false);
						}
						tramosPriceObj.setUITramo(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);
						tramosPriceObj.updateTramoPrize(parseInt(apuestas),objectPurchaseOption.dias,objectPurchaseOption.semanas);

					}else{
						objectPurchaseOption.updatePrice(apuestas);
					}
					if(typeof $(this).closest("tr").attr("data-reducciones-id") !="undefined"){
						var idPersonalizadas=$(this).closest("tr").attr("data-reducciones-id");
					}else{
						if(chooserObj.isReducidaInProgress){
							var idPersonalizadas="reducida";
						}else{
							var idPersonalizadas="directo";
						}
					}
				} else {
					updatePercentages(5, $("[data-select-apuestasId='" + $("[data-select-personalizada-apuestas]").val() + "']"));
					if(typeof tramosPriceObj != "undefined"){
						tramosPriceObj.setUITramo(parseInt($("[data-select-personalizada-apuestas]").val()),objectPurchaseOption.dias,objectPurchaseOption.semanas);
						tramosPriceObj.updateTramoPrize(parseInt($("[data-select-personalizada-apuestas]").val()),objectPurchaseOption.dias,objectPurchaseOption.semanas);
					}else{
						objectPurchaseOption.updatePrice($("[data-select-personalizada-apuestas]").val());
					}
					var idPersonalizadas=$('[data-multiplesummary] [data-select-personalizada-apuestas]:visible option:selected').attr("data-reducciones-id");
				}

					if(typeof idPersonalizadas!="undefined"){
						chooserObj.setMultipleRawValues({ "idReduccion":idPersonalizadas,"apuestas":apuestas});
					}
// 				if(chooserObj.correctBets > 0){
					objectPurchaseOption.setCanBuy(true)
// 				}
			}
		}
	});

	$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		var elem = new Foundation.Equalizer($("[data-equalizer]"),{});
	});
}
function launchBoletoScripts(gameType,chooserObj,purchaseOptionsObj,options){

	var lang_Normal			= "Sencilla";
	var lang_Multiple 		= "Múltiples";
	var lang_Condicionada	= "Condicionadas";
	var lang_Reducida		= "Reducidas";
 	var	lang_msgToMultiple 	= "Has seleccionado más números de los establecidos por apuesta. ¿Quieres que te pasemos a modo múltiple con esta combinación? (Se borrarán el resto de tus apuestas)";
 	var lang_msgToNormal 	= "Estás eligiendo apuesta individual. ¿Estás seguro? (Se borrarán el resto de tus apuestas múltiples)";

	var showWizardOnLoad = true;
	var itemIDforEdition = false;
	var tramosPriceObj = false;

	var manuallySwitchedCallback = function(){}
	var callbackOnAvailableCondicionadas = function(){};
	var callbackOnUnavailableCondicionadas = function(){};

 	if(options){
 		if( typeof options.lang_NormalMultiple 		!= "undefined" ){	lang_NormalMultiple 		= options.lang_NormalMultiple }
 		if( typeof options.lang_Normal 				!= "undefined" ){	lang_Normal 				= options.lang_Normal }
 		if( typeof options.lang_Multiple 			!= "undefined" ){	lang_Multiple 				= options.lang_Multiple }
 		if( typeof options.lang_Condicionada 		!= "undefined" ){	lang_Condicionada 			= options.lang_Condicionada }
 		if( typeof options.lang_Reducida 			!= "undefined" ){	lang_Reducida 				= options.lang_Reducida }
 		if( typeof options.showWizardOnLoad 		!= "undefined" ){	showWizardOnLoad 			= options.showWizardOnLoad }
 		if( typeof options.itemIDforEdition			!= "undefined" ){	itemIDforEdition			= options.itemIDforEdition}
 		if( typeof options.tramosPriceObj			!= "undefined" ){	tramosPriceObj				= options.tramosPriceObj}
 		if( typeof options.lang_msgToMultiple 		!= "undefined" ){	lang_msgToMultiple 			= options.lang_msgToMultiple }
 		if( typeof options.lang_msgToNormal 		!= "undefined" ){	lang_msgToNormal 			= options.lang_msgToNormal }
 		if( typeof options.manuallySwitchedCallback	!= "undefined" ){	manuallySwitchedCallback 	= options.manuallySwitchedCallback }
 		if( typeof options.callbackOnAvailableCondicionadas	!= "undefined" ){	callbackOnAvailableCondicionadas 	= options.callbackOnAvailableCondicionadas }
 		if( typeof options.callbackOnUnavailableCondicionadas	!= "undefined" ){	callbackOnUnavailableCondicionadas 	= options.callbackOnUnavailableCondicionadas }


//  		if( typeof options.purchaseOptionsObj 	!= "undefinded"){	purchaseOptionsObj		= options.purchaseOptionsObj}
 	}

/*
	if(gameType != 5 ){
		boletoInfo = new boletoInfoPanelPro({ "firstTimeDelay":0.3});
	}else{
		boletoInfo = new boletoInfoPanelPro({ "firstTimeDelay":0.3});
	}
*/
	var boletoInfoPanelProOptions = {
		"firstTimeDelay":0.3,
		"showWizardOnLoad":showWizardOnLoad,
		"msgToMultiple":lang_msgToMultiple,
		"msgToNormal":lang_msgToNormal,
		"manuallySwitchedCallback":manuallySwitchedCallback,
		"callbackOnAvailableCondicionadas":callbackOnAvailableCondicionadas,
		"callbackOnUnavailableCondicionadas":callbackOnUnavailableCondicionadas
	}
	if(tramosPriceObj){
		boletoInfoPanelProOptions["tramosPriceObj"] = tramosPriceObj;
	}

	var boletoInfo = new boletoInfoPanelPro(chooserObj,purchaseOptionsObj,boletoInfoPanelProOptions);
	if(showWizardOnLoad){
	boletoInfo.showPanel('wizard');
	}else{
		boletoInfo.showPanel('normal');

	}
	if(tramosPriceObj){
		multipleSelectionTable(purchaseOptionsObj,chooserObj,tramosPriceObj);
	}else{
		multipleSelectionTable(purchaseOptionsObj,chooserObj);
	}
	countersEvents({ 'max':99,'min':1});

	$('[data-btPlayNormal]').on('click',function(){
		if( !$(this).closest('li').hasClass('is-active')){
			boletoInfo.userSwitchedManual=true;
			boletoInfo.showPanel('normal');
			boletoInfo.manuallySwitchedCallback("normal",boletoInfo);
 		}
	})
	$('[data-btPlayMultiple]').on('click',function(){
		if( !$(this).closest('li').hasClass('is-active')){
			boletoInfo.userSwitchedManual=true;
			boletoInfo.manuallySwitchedCallback("multiple",boletoInfo);
			boletoInfo.showPanel('multiple');
 		}
	})
	$('[data-btPlayReducidas]').on('click',function(){
		if( !$(this).closest('li').hasClass('is-active')){
			boletoInfo.userSwitchedManual=true;
			boletoInfo.manuallySwitchedCallback("reducidas",boletoInfo);
			boletoInfo.showPanel('reducidas');
 		}
	})
	$('[data-btPlayCondicionadas]').on('click',function(){
		if( !$(this).closest('li').hasClass('is-active')){
			boletoInfo.userSwitchedManual=true;
			boletoInfo.manuallySwitchedCallback("condicionadas",boletoInfo);
			boletoInfo.showPanel('condicionadas');
		}
	})
	$('[data-btSendFile]').on('click',function(){
		if( !$(this).closest('li').hasClass('is-active')){
			boletoInfo.userSwitchedManual=true;
			boletoInfo.manuallySwitchedCallback("sendfile",boletoInfo);
			boletoInfo.showPanel('sendFile');
		}
	})
	$('[data-boleto] [data-setup]').off('click').on('click',function(){
		$('html, body').animate({
	 			scrollTop: $('[data-infoMultiple]').offset().top-50
 		}, 300)
	})
	return boletoInfo;

}

/*********************/
/* ENVÍO DE FICHEROS */
/*********************/
function sendFicherosScripts(currentGameType,options){
	this.gameType=currentGameType;
	this.actionURL="/data/?action=fileToBets";
	this.confirmMsg="Si continúas, tu apuesta actual se borrará y tendrás que volver a elegir tus combinaciones. ¿Estás seguro?";
	this.ajaxObjParams=false;
	this.scriptFromBoleto=false;
	this.purchaseOptionsObj=false; //Necesario para calcular importes
	this.boletoInfoObj=false;		//Necesario para manejar la interfaz
	this.tramosPriceObj=false;
	this.parsedData=false;
	if(typeof options!="undefined"){
		if(typeof options.confirmMsg!="undefined"){	this.confirmMsg=options.confirmMsg	}
		if(typeof options.ajaxObjParams!="undefined"){	this.ajaxObjParams=options.ajaxObjParams	}
		if(typeof options.scriptFromBoleto!="undefined"){	this.scriptFromBoleto=options.scriptFromBoleto	}
		if(typeof options.purchaseOptionsObj!="undefined"){	this.purchaseOptionsObj=options.purchaseOptionsObj	}
		if(typeof options.tramosPriceObj!="undefined"){	this.tramosPriceObj=options.tramosPriceObj	}
		if(typeof options.boletoInfoObj!="undefined"){	this.boletoInfoObj=options.tramosPriceObj	}
	}

	var parentObj=this;
	$('#betFileSend input[type=file]').on('click',function(){
		if(!window.confirm(confirmMsg)){
			return false;
		}else{
			var w_width;
			var w_height;
			w_width=$('[data-boleto_info][data-infoFile]').width();
			w_height=$('[data-boleto_info][data-infoFile]').height();
			$('[data-boleto_info][data-infofile]').css({
				'width':w_width+"px",
				'height':w_height+"px"
			}
			)//.addClass('is-locked');
			parentObj.purchaseOptionsObj.numberChooserObj.resetBoleto()
		/* 	$('.navBoleto > *:not([data-infofile])').hide(); */ //Vaciamos boleto para no enviar datos mezclados
			$('[data-boleto_info][data-infofile] .close-button').on('click',function(){
				$('[data-boleto-container]').css('height',$('[data-boleto-container]').height()+"px");
				loadDynamicBoleto(currentGameType,$('[data-boleto] [data-boleto-container]'),$('[data-boleto-container]'),parentObj.scriptFromBoleto,{ "ignoreCookies":true,"ignoreFileSending":false});
			})
		};
	})
	$('#betFileSend input[type=file]').on('change',function(){
		function betsSendCallback(data){
			$('#betFileSend [data-ok]').html(data.data.correctas);
			$('#betFileSend [data-ko]').html(data.data.incorrectas);
			$('[data-fileverification]').addClass('is-active');
			purchaseOptionsObj.numeroApuestas = data.data.correctas;
			if(parentObj.tramosPriceObj){
				tramosPriceObj.setUITramo(parseInt(data.data.correctas),parentObj.purchaseOptionsObj.dias,parentObj.purchaseOptionsObj.semanas);
				tramosPriceObj.updateTramoPrize(parseInt(data.data.correctas),parentObj.purchaseOptionsObj.dias,parentObj.purchaseOptionsObj.semanas);
			}else{
				parentObj.purchaseOptionsObj.updatePrice(data.data.correctas);
			}
			parentObj.purchaseOptionsObj.setCanBuy(true);
			parentObj.parsedData = parseGameSelection(parentObj.gameType,{ desarrollo:data.data.desarrollo});
			parentObj.parsedData.gameMode = 1;
			parentObj.parsedData.byFile = true;
			parentObj.purchaseOptionsObj.betsFromFile = parentObj.parsedData;
			parentObj.boletoInfoObj.fileSent = true;
			//Enviar importes a ctrlpurchaseoptions
		}
		parentObj.ajaxObjParams.callbackOnSuccess=betsSendCallback;
		parentObj.ajaxObjParams.sendAsFile=true;
		myForm = new formeSubmit($('[data-boleto_info][data-infofile] form'),parentObj.actionURL,parentObj.ajaxObjParams);
	})

}


//FUNCION QUE ALTERNA ENTRE MODO PROBABILIDAD Y MODO 1X2 PARA LAS CASILLAS DE SELECCIÓN
function setQuinielaMode(mode,probString){
	//mode == 1 -> Probabilidades
	//mode == 0 -> 1X2
	//probString = "60,22,18-37,30,33-61,21,18-54,26,20-33,30,37-41,29,30-51,28,21-46,29,25-28,26,46-42,32,26-26,24,50-30,27,43-63,22,15-61,23,16-9,24,40,20-10,10,10,0";

	var probStr = null
	var probArray = new Array()
	if(typeof probString != "undefined"){
		probStr = probString
	}

	if(mode == 1 && probStr != null){
		probArray = probStr.split ("-")
		$("table.quiniela tr").each(function(){
			switchElems($(this),1)
		})
	}else if (mode == 0) {
		$("table.quiniela tr").each(function(){
			switchElems($(this),0)
		})
	}

	function switchElems(trElem,mode){
		//mode == 1 -> Probabilidades
		//mode == 0 -> 1X2
		var thisTRprobs = probArray[$(trElem).index()]

		$(trElem).find('[data-quinielacolumn]:not([data-columna-extra])').each(function(){
			$(this).find('label').each(function(){
				if(mode == 1){
					$(this)[0].childNodes[0].nodeValue = thisTRprobs.split(",")[$(this).index()]
				}else if(mode == 0){
					if($(this).index() == 0){
						$(this)[0].childNodes[0].nodeValue = "0"
					}else if($(this).index() == 1){
						$(this)[0].childNodes[0].nodeValue = "1"
					}else if($(this).index() == 2){
						$(this)[0].childNodes[0].nodeValue = "2"
					}else if($(this).index() == 3){
						$(this)[0].childNodes[0].nodeValue = "M"
					}
				}
			})
		})
	}
}
function checksumProbabilidades(probString){
	//Validador de que están todos los elementos
	if(typeof probString == "undefined" || probString.length == 0){
		return false
	}
	var countElems = 0
	var probArray = new Array()
	probArray = probString.split("-")
	if(probArray.length != 16){
		console.log("Partidos incompletos o no coincidentes:",probArray.length)
		return false
	}else{
		$(probArray).each(function(){
			var probs = this.split(",")
			countElems = countElems + probs.length
		})
		if(countElems == (16*3) + 2){
			return true
		}else{
			console.log("Valores incompletos o no coincidentes")
			return false
		}
	}

}






/*
 * Original code (c) 2010 Nick Galbreath
 * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
 *
 * jQuery port (c) 2010 Carlo Zottmann
 * http://github.com/carlo/jquery-base64
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
*/

/* base64 encode/decode compatible with window.btoa/atob
 *
 * window.atob/btoa is a Firefox extension to convert binary data (the "b")
 * to base64 (ascii, the "a").
 *
 * It is also found in Safari and Chrome.  It is not available in IE.
 *
 * if (!window.btoa) window.btoa = $.base64.encode
 * if (!window.atob) window.atob = $.base64.decode
 *
 * The original spec's for atob/btoa are a bit lacking
 * https://developer.mozilla.org/en/DOM/window.atob
 * https://developer.mozilla.org/en/DOM/window.btoa
 *
 * window.btoa and $.base64.encode takes a string where charCodeAt is [0,255]
 * If any character is not [0,255], then an exception is thrown.
 *
 * window.atob and $.base64.decode take a base64-encoded string
 * If the input length is not a multiple of 4, or contains invalid characters
 *   then an exception is thrown.
 */

jQuery.base64 = ( function( $ ) {

  var _PADCHAR = "=",
    _ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
    _VERSION = "1.0";


  function _getbyte64( s, i ) {
    // This is oddly fast, except on Chrome/V8.
    // Minimal or no improvement in performance by using a
    // object with properties mapping chars to value (eg. 'A': 0)

    var idx = _ALPHA.indexOf( s.charAt( i ) );

    if ( idx === -1 ) {
      throw "Cannot decode base64";
    }

    return idx;
  }


  function _decode( s ) {
    var pads = 0,
      i,
      b10,
      imax = s.length,
      x = [];

    s = String( s );

    if ( imax === 0 ) {
      return s;
    }

    if ( imax % 4 !== 0 ) {
      throw "Cannot decode base64";
    }

    if ( s.charAt( imax - 1 ) === _PADCHAR ) {
      pads = 1;

      if ( s.charAt( imax - 2 ) === _PADCHAR ) {
        pads = 2;
      }

      // either way, we want to ignore this last block
      imax -= 4;
    }

    for ( i = 0; i < imax; i += 4 ) {
      b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 ) | _getbyte64( s, i + 3 );
      x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff, b10 & 0xff ) );
    }

    switch ( pads ) {
      case 1:
        b10 = ( _getbyte64( s, i ) << 18 ) | ( _getbyte64( s, i + 1 ) << 12 ) | ( _getbyte64( s, i + 2 ) << 6 );
        x.push( String.fromCharCode( b10 >> 16, ( b10 >> 8 ) & 0xff ) );
        break;

      case 2:
        b10 = ( _getbyte64( s, i ) << 18) | ( _getbyte64( s, i + 1 ) << 12 );
        x.push( String.fromCharCode( b10 >> 16 ) );
        break;
    }

    return x.join( "" );
  }


  function _getbyte( s, i ) {
    var x = s.charCodeAt( i );

    if ( x > 255 ) {
      throw "INVALID_CHARACTER_ERR: DOM Exception 5";
    }

    return x;
  }


  function _encode( s ) {
    if ( arguments.length !== 1 ) {
      throw "SyntaxError: exactly one argument required";
    }

    s = String( s );

    var i,
      b10,
      x = [],
      imax = s.length - s.length % 3;

    if ( s.length === 0 ) {
      return s;
    }

    for ( i = 0; i < imax; i += 3 ) {
      b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 ) | _getbyte( s, i + 2 );
      x.push( _ALPHA.charAt( b10 >> 18 ) );
      x.push( _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) );
      x.push( _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) );
      x.push( _ALPHA.charAt( b10 & 0x3f ) );
    }

    switch ( s.length - imax ) {
      case 1:
        b10 = _getbyte( s, i ) << 16;
        x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _PADCHAR + _PADCHAR );
        break;

      case 2:
        b10 = ( _getbyte( s, i ) << 16 ) | ( _getbyte( s, i + 1 ) << 8 );
        x.push( _ALPHA.charAt( b10 >> 18 ) + _ALPHA.charAt( ( b10 >> 12 ) & 0x3F ) + _ALPHA.charAt( ( b10 >> 6 ) & 0x3f ) + _PADCHAR );
        break;
    }

    return x.join( "" );
  }


  return {
    decode: _decode,
    encode: _encode,
    VERSION: _VERSION
  };

}( jQuery ) );